import React from 'react';
import { CenteredLoadingSpinner, useFeature } from '@ole-ui/ole-ui-components';
import { observer } from 'mobx-react';
import { withErrorBoundary } from 'react-error-boundary';
import ComponentError from 'components/Error/ComponentError';
import { handleError } from 'services/ErrorService';
import useMobxStores from 'hooks/useMobxStores';
import { EnablementFeatureFlags } from 'config/featureFlags';
import LegacyHome from './HomeV1';
import NewHome from './HomeV2';

import './styles.scss';

const Home = () => {
  const { featuresStore } = useMobxStores();
  const isNewHomeEnabled = useFeature({
    section: 'enablements',
    flagName: EnablementFeatureFlags.NewHomePage,
    defaultFlagValue: false,
  });

  if (!featuresStore.allFeaturesFetched) {
    return (
      <div className="home__loading">
        <CenteredLoadingSpinner />
      </div>
    );
  }

  if (!isNewHomeEnabled) {
    return <LegacyHome />;
  }

  return <NewHome />;
};

export default withErrorBoundary(observer(Home), ComponentError, handleError);
